import React from 'react';
import { Box, Typography } from '@mui/material';

export interface ScoreStatusProps {
  score: number;
}

const getStatusDetails = (score: number) => {
  if (score >= 85) {
    return { color: '#22c55e' };
  } else if (score >= 70) {
    return { color: '#3b82f6' };
  } else if (score >= 50) {
    return { color: '#eab308' };
  } else {
    return { color: '#ef4444' };
  }
};

export const ScoreStatus: React.FC<ScoreStatusProps> = ({ score }) => {
  const { color } = getStatusDetails(score);

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
      <Box
        component='span'
        sx={{
          width: 12,
          height: 12,
          borderRadius: '50%',
          bgcolor: color,
        }}
      />
      <Typography
        variant='body2'
        sx={{ color: 'text.primary', fontWeight: 500 }}
      >
        {score}%
      </Typography>
    </Box>
  );
};

export default ScoreStatus;
